import { FC } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@new/common/ui';
import { teachurKeys, useResumeCourseMutation } from '@teachur/http-client';
import { useSingleCourse } from '@new/features/courses/contexts/SingleCourseProvider';
import { getErrorMessage } from '@new/lib';

export const ResumeCourseContent: FC = () => {
  const queryClient = useQueryClient();
  const { course, setActiveStep } = useSingleCourse();

  const resumeCourseMutation = useResumeCourseMutation({
    onSuccess: (_, courseId) => {
      queryClient.invalidateQueries({ queryKey: teachurKeys.courses.completion(courseId) });
      queryClient.invalidateQueries({ queryKey: teachurKeys.courses.detail(courseId) });
      setActiveStep('self');
    },
    onError: (error: unknown) => {
      const message = getErrorMessage(error, 'Failed to resume course');
      toast.error(message);
    },
  });

  if (!course || !course.isPaused) return null;

  const onClickResumeCourse = () => {
    resumeCourseMutation.mutate(course.id);
  };

  return (
    <Button
      variant="primary"
      onClick={onClickResumeCourse}
      disabled={resumeCourseMutation.isPending}
      className="[font-size:var(--fs-p1)]! p-5! h-full!"
    >
      {resumeCourseMutation.isPending ? 'Resuming...' : 'Resume Course'}
    </Button>
  );
};
